export default __webpack_public_path__ + "static/media/team-1-800x800.10691648.png";